import { render } from "./ReturnClientComponent.vue?vue&type=template&id=a8ba5e66"
import script from "./ReturnClientComponent.vue?vue&type=script&lang=js"
export * from "./ReturnClientComponent.vue?vue&type=script&lang=js"

import "./ReturnClientComponent.vue?vue&type=style&index=0&id=a8ba5e66&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__